export const initialMessageSetting = [
  {name: '%DATE%', value: 'Used to insert into the date template'},
  {name: '%AMOUNT%', value: 'Used to insert into the amount template'},
  {name: '%LOAN_ID%', value: 'Used to insert into the loan ID template'},
]